import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=2b1e76e9"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=2b1e76e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports